import ConsolidadoPreview from "./ConsolidadoPreview";
export default ConsolidadoPreview;